import CmModal from "./CmModal";

const Dialog = ({ open, onClose, title, children, actions, size = "default" }) => {
  return (
    <CmModal
      open={open}
      onClose={onClose}
      title={title}
      footer={actions}
      size={size}
    >
      {children}
    </CmModal>
  );
};

export default Dialog;
